import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({ providedIn: 'root' })
export class InventarioOrquestradorService extends CommonService {
  private readonly apiUrl: string = environment.urlApiOrquestradorSuprimentos + 'InventarioOrquestrador';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public processar(idInventario: number): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/idInventario/${idInventario}/processar`, {}, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
